import React from 'react';

import styles from './CleanerShortDetails.module.scss';
import avatar from "../../constants/images/avatar.svg";

const CleanerShortDetails = ({photo, firstName, lastName, phoneNumber}) => {
    return (
        <div className={styles.cleanerShortDetails}>
            <p className={styles.cleanerShortDetails_subtitle}>Клінер</p>
            <div className={styles.cleanerShortDetails_bio}>
                <img className={styles.photo} src={photo || avatar} alt="cleaner`s photo"/>
                <div className={styles.cleanerShortDetails_bio_description}>
                    <p>{firstName} {lastName}</p>
                    <p>{phoneNumber}</p>
                </div>
            </div>
        </div>
    );
};

export default CleanerShortDetails;
